export const SALES_OPS_TOGGLES = {
  contactRewriteAfter: 'msg_contract_rewrite',
  inHouseSystemAfter: 'msg_in_house_system',
  dealerDemoKitAfter: 'msg_dealer_demo_kit',
  isUseESigDocumentsFlowAfter: 'msg_use_electronic_signature_flow',
  cxConfigDiscountPromoEnabledAfter: 'msg_cx_config_discount_promo',
};
